/* 10/10/2026 (Luca): nel carrello la foto si tocca e si vede grande — «uno è sorpreso e dice: ah, ma qui sono le mie perline bianche?
   Fammi cliccare e così la vedo». Vale per la tendina e per la pagina del carrello. Toccare la foto non porta più alla scheda: ci porta il nome.
   La foto grande è in data-gg-zoom sul contenitore (cart-drawer-item.liquid, main-cart-items.liquid); si chiude con la X, toccando
   ovunque, o con Esc. Caricato da due posti: la guardia evita il doppio ascoltatore. */
(function () {
  if (window.ggZoomCarrello) return;
  window.ggZoomCarrello = true;
  var SEL = '.f-cart-drawer__product-image[data-gg-zoom], .f-cart-item__image[data-gg-zoom]';
  var velo = null, prima = null;

  function chiudi() {
    if (!velo) return;
    velo.remove(); velo = null;
    document.removeEventListener('keydown', suEsc, true);
    if (prima && prima.focus) prima.focus();
  }
  function suEsc(e) { if (e.key === 'Escape') { e.stopPropagation(); chiudi(); } }

  // subito la foto piccola già caricata, poi la grande appena arriva: la prima volta Shopify la prepara e ci mette qualche secondo,
  // e uno zoom vuoto sembra rotto (10/10/2026, provato nel browser dell'app)
  function apri(src, alt, piccola) {
    chiudi();
    prima = document.activeElement;
    velo = document.createElement('div');
    velo.className = 'gg-zoom';
    velo.setAttribute('role', 'dialog');
    velo.setAttribute('aria-modal', 'true');
    velo.setAttribute('aria-label', alt || 'Foto ingrandita');
    velo.innerHTML = '<button type="button" class="gg-zoom__x" aria-label="Chiudi">×</button><img class="gg-zoom__img" alt="">';
    var img = velo.querySelector('img'); img.alt = alt || '';
    img.src = piccola || src;
    if (piccola && piccola !== src) {
      var grande = new Image();
      grande.onload = function () { if (img.isConnected) img.src = src; };
      grande.src = src;
    }
    velo.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); chiudi(); });
    document.body.appendChild(velo);
    document.addEventListener('keydown', suEsc, true);
    velo.querySelector('.gg-zoom__x').focus();
  }

  // in cattura: il link sopra la foto (full-width-link) e la tendina non devono vedere il tocco
  document.addEventListener('click', function (e) {
    var box = e.target.closest && e.target.closest(SEL);
    if (!box) return;
    e.preventDefault(); e.stopPropagation();
    var img = box.querySelector('img');
    apri(box.getAttribute('data-gg-zoom'), img ? img.alt : '', img ? (img.currentSrc || img.src) : '');
  }, true);
})();
